import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Container } from 'react-bootstrap';
import { Logo } from '../Logo/Logo';
import './Footer.scss';
import { AppDownload } from '../AppDownload/AppDownload';
import { useEffect, useState } from 'react';
import { useCapacitor } from '../../../hooks/useCapacitor';
import { useMobileDetect } from '../../../hooks/useMobileDetect';
import { Legalese } from '../Legalese/Legalese';
import { faLifeRing } from '@fortawesome/free-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import { faCodeBranch, faGift } from '@fortawesome/free-solid-svg-icons';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { LanguageSelector } from '../LanguageSelector/LanguageSelector';
import { isItalian } from '../../utils/utils';
import { useGeolocation } from '../../../contexts/GeolocationContext';

const FooterComponent = () => {
  const [suggestApp, setSuggestApp] = useState(false);
  const { isNative } = useCapacitor();
  const { isMobile, isTV } = useMobileDetect();
  const { t } = useTranslation();
  const { staticData } = useFirebase();
  const { country_code } = useGeolocation();
  const { userDataFmt } = useFirebase();

  useEffect(() => {
    setSuggestApp(isMobile && !isNative);
  }, [isMobile, isNative]);

  if (isNative) return null;

  return (
    <div className={`bottom-footer ${suggestApp ? 'pb-8rem' : ''}`}>
      <Container>
        <div className={'d-flex justify-content-center align-items-center flex-wrap footer-row'}>
          <Logo className={'logo-tootor mr-3'} variant={'light'} />
          <div className={'d-flex flex-wrap align-items-center'}>
            {!isTV && userDataFmt?.profile?.formData?.categoriaProfessionale !== 'aso' && <LanguageSelector className={'mr-2'} />}
            <Button variant={'primary'} size={'sm'} className={'mr-2'} href={'/help'}>
              <div className={'d-flex align-items-center'}>
                <FontAwesomeIcon icon={faLifeRing} className={'mr-2'} />
                <span>{t('labels.helpCenter')}</span>
              </div>
            </Button>
            {staticData.SHOW_COLLABORATE && (
              <Button variant={'dark'} size={'sm'} className={'mr-2'} href={'/collaborate'}>
                <div className={'d-flex align-items-center'}>
                  <FontAwesomeIcon icon={faCodeBranch} className={'mr-2'} />
                  <span>{t('labels.lavoraConNoi')}</span>
                </div>
              </Button>
            )}
            {!isNative && staticData.ENABLE_GIFTS && isItalian(country_code) && (
              <Button variant={'dark'} size={'sm'} href={'/gift'}>
                <div className={'d-flex align-items-center'}>
                  <FontAwesomeIcon icon={faGift} className={'mr-2'} />
                  <span>{t('labels.regalaAbbonamento')}</span>
                </div>
              </Button>
            )}
          </div>
        </div>
        <small className={'text-muted d-flex flex-wrap footer-legalese'}>
          <Legalese />
        </small>
        {isMobile && !isNative && (
          <div className={'mt-2'}>
            <AppDownload className={'d-flex justify-content-center align-items-center'} />
          </div>
        )}
      </Container>
    </div>
  );
};

export { FooterComponent as Footer };
